import {OperationErrorType, StoreAction} from "orpyx-web-common";
import { CachedInsightImage } from "../patient-information-daily-insights.interface";

export enum PatientInformationDailyInsightsIndexActions {
    RESET_PATIENT_INFORMATION_DAILY_INSIGHTS = 'PATIENT_INFORMATION_DAILY_INSIGHTS: RESET_PATIENT_INFORMATION_DAILY_INSIGHTS',
    GET_PATIENT_INFORMATION_DAILY_INSIGHTS = 'PATIENT_INFORMATION_DAILY_INSIGHTS: GET_PATIENT_INFORMATION_DAILY_INSIGHTS',
    GET_PATIENT_INFORMATION_DAILY_INSIGHTS_SUCCESSFULLY = 'PATIENT_INFORMATION_DAILY_INSIGHTS: GET_PATIENT_INFORMATION_DAILY_INSIGHTS_SUCCESSFULLY',
    GET_PATIENT_INFORMATION_DAILY_INSIGHTS_FAILED = 'PATIENT_INFORMATION_DAILY_INSIGHTS: GET_PATIENT_INFORMATION_DAILY_INSIGHTS_FAILED',
}
export enum PatientInformationDailyInsightsNavigationActions {
    NAVIGATE_TO_DAILY_INSIGHTS_NEXT = 'PATIENT_INFORMATION_DAILY_INSIGHTS: NAVIGATE_TO_DAILY_INSIGHTS_NEXT',
    NAVIGATE_TO_DAILY_INSIGHTS_PREVIOUS = 'PATIENT_INFORMATION_DAILY_INSIGHTS: NAVIGATE_TO_DAILY_INSIGHTS_PREVIOUS',
    NAVIGATE_TO_DAILY_INSIGHTS_LATEST = 'PATIENT_INFORMATION_DAILY_INSIGHTS: NAVIGATE_TO_DAILY_INSIGHTS_LATEST',
}
export enum PatientInformationDailyInsightsCachingActions {
    FETCH_SINGLE_DAILY_INSIGHTS_IMAGE = 'PATIENT_INFORMATION_DAILY_INSIGHTS: FETCH_SINGLE_DAILY_INSIGHTS_IMAGE',
    FETCH_SINGLE_DAILY_INSIGHTS_IMAGE_SUCCESSFULLY = 'PATIENT_INFORMATION_DAILY_INSIGHTS: FETCH_SINGLE_DAILY_INSIGHTS_IMAGE_SUCCESSFULLY',
    FETCH_SINGLE_DAILY_INSIGHTS_IMAGE_FAILED = 'PATIENT_INFORMATION_DAILY_INSIGHTS: FETCH_SINGLE_DAILY_INSIGHTS_IMAGE_FAILED',
    RELOAD_CURRENT_INSIGHT_IMAGE = 'PATIENT_INFORMATION_DAILY_INSIGHTS: RELOAD_CURRENT_INSIGHT_IMAGE',
}

export const RESET_PATIENT_INFORMATION_DAILY_INSIGHTS = (): StoreAction<PatientInformationDailyInsightsIndexActions> => ({
    type: PatientInformationDailyInsightsIndexActions.RESET_PATIENT_INFORMATION_DAILY_INSIGHTS
});

export const GET_PATIENT_INFORMATION_DAILY_INSIGHTS = (date?: string, quantity?: number): StoreAction<PatientInformationDailyInsightsIndexActions> => ({
    type: PatientInformationDailyInsightsIndexActions.GET_PATIENT_INFORMATION_DAILY_INSIGHTS,
    payload: { date: date, quantity: quantity}
});

export const GET_PATIENT_INFORMATION_DAILY_INSIGHTS_SUCCESSFULLY = (insights: CachedInsightImage[]): StoreAction<PatientInformationDailyInsightsIndexActions> => ({
    type: PatientInformationDailyInsightsIndexActions.GET_PATIENT_INFORMATION_DAILY_INSIGHTS_SUCCESSFULLY, 
    payload: insights,
});


export const GET_PATIENT_INFORMATION_DAILY_INSIGHTS_FAILED = (error: OperationErrorType): StoreAction<PatientInformationDailyInsightsIndexActions> => ({
    type: PatientInformationDailyInsightsIndexActions.GET_PATIENT_INFORMATION_DAILY_INSIGHTS_FAILED, 
    payload: error
});

export const NAVIGATE_TO_DAILY_INSIGHTS_NEXT = (): StoreAction<PatientInformationDailyInsightsNavigationActions> => ({
    type: PatientInformationDailyInsightsNavigationActions.NAVIGATE_TO_DAILY_INSIGHTS_NEXT,
});

export const NAVIGATE_TO_DAILY_INSIGHTS_PREVIOUS = (): StoreAction<PatientInformationDailyInsightsNavigationActions> => ({
    type: PatientInformationDailyInsightsNavigationActions.NAVIGATE_TO_DAILY_INSIGHTS_PREVIOUS
});

export const NAVIGATE_TO_DAILY_INSIGHTS_LATEST = (): StoreAction<PatientInformationDailyInsightsNavigationActions> => ({
    type: PatientInformationDailyInsightsNavigationActions.NAVIGATE_TO_DAILY_INSIGHTS_LATEST,
});


export const FETCH_SINGLE_DAILY_INSIGHTS_IMAGE = (insight: CachedInsightImage): StoreAction<PatientInformationDailyInsightsCachingActions> => ({
    type: PatientInformationDailyInsightsCachingActions.FETCH_SINGLE_DAILY_INSIGHTS_IMAGE,
    payload: insight,
});

export const FETCH_SINGLE_DAILY_INSIGHTS_IMAGE_SUCCESSFULLY = (date: string, blobUrl: string): StoreAction<PatientInformationDailyInsightsCachingActions> => ({
    type: PatientInformationDailyInsightsCachingActions.FETCH_SINGLE_DAILY_INSIGHTS_IMAGE_SUCCESSFULLY,
    payload: {date: date, blobUrl: blobUrl}
});

export const FETCH_SINGLE_DAILY_INSIGHTS_IMAGE_FAILED = (date: string, error: OperationErrorType): StoreAction<PatientInformationDailyInsightsCachingActions> => ({
    type: PatientInformationDailyInsightsCachingActions.FETCH_SINGLE_DAILY_INSIGHTS_IMAGE_FAILED,
    payload: {date: date, error: error}
});

export const RELOAD_CURRENT_INSIGHT_IMAGE = (): StoreAction<PatientInformationDailyInsightsCachingActions> => ({
    type: PatientInformationDailyInsightsCachingActions.RELOAD_CURRENT_INSIGHT_IMAGE
})


